import React from "react";
import ArrowIcon from "../../../Svg/ArrowIcon";
import { CharacteristicProps } from "./types";
import classes from "./Characteristic.module.scss";

export const NOT_VALID_MSG = "некорректное значение";

const Characteristic = ({
    title,
    children,
    value,
    noDivider = false,
    isValid = true,
    notValidLabel = NOT_VALID_MSG
}: CharacteristicProps) => {
    const [isExpanded, setIsExpanded] = React.useState(true);
    return (
        <div
            className={`${classes.Characteristic} ${isExpanded ? classes.ExpandedMode : classes.NotExpandedMode}`}
        >
            <div className={classes.Header} onClick={() => setIsExpanded(!isExpanded)}>
                <label className={`${isValid ? null : classes.NotValid}`}>
                    {isValid ? title : `${title} (${notValidLabel})`}
                </label>
                <div className={classes.RightPartHeader}>
                    {!isExpanded && !!value && value.toString() !== "NaN" && (
                        <div className={classes.ValueCont}>{value.toString()}</div>
                    )}
                    <div
                        className={`${classes.ExpandBtn} ${isExpanded ? classes.Expanded : undefined}`}
                    >
                        <ArrowIcon />
                    </div>
                </div>
            </div>

            {isExpanded && children}
            {!noDivider && <div className={classes.Divider}></div>}
        </div>
    );
};
export default Characteristic;